import axios from 'axios';
import { basicAuthConfig } from '../configs';
import { urlMyspreadApi } from '../urls';

/**
 * Obtener tipos de flota
 * @param {Object} user - Usuario autenticado
 * @param {Object} params - { pageSize, pageNumber, searchValue }
 * @returns {Promise} Response con lista de tipos de flota y total
 */
export const getTiposFlota = async (user, params = {}) => {
  try {
    const config = basicAuthConfig(user);
    let endpoint = urlMyspreadApi.replace(/\/$/, '') + '/mantenedores/generales/tipos-flota';
    
    const query = [];
    if (params.pageSize) query.push(`pageSize=${params.pageSize}`);
    if (params.pageNumber) query.push(`pageNumber=${params.pageNumber}`);
    if (params.searchValue && params.searchValue.length > 0) {
      query.push(`searchValue=${encodeURIComponent(params.searchValue)}`);
    }
    
    if (query.length > 0) {
      endpoint += '?' + query.join('&');
    }
    
    const response = await axios.get(endpoint, config);
    
    if (response.data) {
      return {
        success: true,
        data: response.data.data,
        total: response.data.total,
        message: response.data.message
      };
    }
    
    return {
      success: false,
      error: 'No se recibieron datos del servidor',
      data: [],
      total: 0
    };
  } catch (error) {
    console.error('Error al obtener tipos de flota:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener tipos de flota',
      data: [],
      total: 0
    };
  }
};

/**
 * Obtener centros de despacho
 * @param {Object} user - Usuario autenticado
 * @param {Object} params - { pageSize, pageNumber, searchValue }
 * @returns {Promise} Response con lista de centros de despacho y total
 */
export const getCentrosDespacho = async (user, params = {}) => {
  try {
    const config = basicAuthConfig(user);
    let endpoint = urlMyspreadApi.replace(/\/$/, '') + '/mantenedores/generales/centros-despacho';
    
    const query = [];
    if (params.pageSize) query.push(`pageSize=${params.pageSize}`);
    if (params.pageNumber) query.push(`pageNumber=${params.pageNumber}`);
    if (params.searchValue && params.searchValue.length > 0) {
      query.push(`searchValue=${encodeURIComponent(params.searchValue)}`);
    }
    
    if (query.length > 0) {
      endpoint += '?' + query.join('&');
    }
    
    const response = await axios.get(endpoint, config);
    
    if (response.data) {
      return {
        success: true,
        data: response.data.data,
        total: response.data.total,
        message: response.data.message
      };
    }
    
    return {
      success: false,
      error: 'No se recibieron datos del servidor',
      data: [],
      total: 0
    };
  } catch (error) {
    console.error('Error al obtener centros de despacho:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener centros de despacho',
      data: [],
      total: 0
    };
  }
};

/**
 * Obtener sistemas TMS
 * @param {Object} user - Usuario autenticado
 * @param {Object} params - { pageSize, pageNumber, searchValue }
 * @returns {Promise} Response con lista de sistemas TMS y total
 */
export const getTMS = async (user, params = {}) => {
  try {
    const config = basicAuthConfig(user);
    let endpoint = urlMyspreadApi.replace(/\/$/, '') + '/mantenedores/generales/tms';
    
    const query = [];
    if (params.pageSize) query.push(`pageSize=${params.pageSize}`);
    if (params.pageNumber) query.push(`pageNumber=${params.pageNumber}`);
    if (params.searchValue && params.searchValue.length > 0) {
      query.push(`searchValue=${encodeURIComponent(params.searchValue)}`);
    }
    
    if (query.length > 0) {
      endpoint += '?' + query.join('&');
    }
    
    const response = await axios.get(endpoint, config);
    
    if (response.data) {
      return {
        success: true,
        data: response.data.data,
        total: response.data.total,
        message: response.data.message
      };
    }
    
    return {
      success: false,
      error: 'No se recibieron datos del servidor',
      data: [],
      total: 0
    };
  } catch (error) {
    console.error('Error al obtener sistemas TMS:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener sistemas TMS',
      data: [],
      total: 0
    };
  }
};

/**
 * Obtener tipos de documento
 * @param {Object} user - Usuario autenticado
 * @param {Object} params - { pageSize, pageNumber, searchValue }
 * @returns {Promise} Response con lista de tipos de documento y total
 */
export const getTiposDocumento = async (user, params = {}) => {
  try {
    const config = basicAuthConfig(user);
    let endpoint = urlMyspreadApi.replace(/\/$/, '') + '/mantenedores/generales/tipos-documento';
    
    const query = [];
    if (params.pageSize) query.push(`pageSize=${params.pageSize}`);
    if (params.pageNumber) query.push(`pageNumber=${params.pageNumber}`);
    if (params.searchValue && params.searchValue.length > 0) {
      query.push(`searchValue=${encodeURIComponent(params.searchValue)}`);
    }
    
    if (query.length > 0) {
      endpoint += '?' + query.join('&');
    }
    
    const response = await axios.get(endpoint, config);
    
    if (response.data) {
      return {
        success: true,
        data: response.data.data,
        total: response.data.total,
        message: response.data.message
      };
    }
    
    return {
      success: false,
      error: 'No se recibieron datos del servidor',
      data: [],
      total: 0
    };
  } catch (error) {
    console.error('Error al obtener tipos de documento:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener tipos de documento',
      data: [],
      total: 0
    };
  }
};

/**
 * Obtener comunas
 * @param {Object} user - Usuario autenticado
 * @returns {Promise} Response con lista de comunas
 */
export const getComunas = async (user) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/generales/comunas`;
    
    const response = await axios.get(endpoint, config);
    
    return {
      success: true,
      data: response.data.data || [],
      total: response.data.total || 0,
      message: response.data.message || 'Comunas obtenidas exitosamente'
    };
  } catch (error) {
    console.error('Error al obtener comunas:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener comunas',
      data: [],
      total: 0
    };
  }
};

/**
 * Obtener regiones
 * @param {Object} user - Usuario autenticado
 * @returns {Promise} Response con lista de regiones
 */
export const getRegiones = async (user) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/generales/regiones`;
    
    const response = await axios.get(endpoint, config);
    
    return {
      success: true,
      data: response.data.data || [],
      total: response.data.total || 0,
      message: response.data.message || 'Regiones obtenidas exitosamente'
    };
  } catch (error) {
    console.error('Error al obtener regiones:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener regiones',
      data: [],
      total: 0
    };
  }
};

/**
 * Obtener servicios spread
 * @param {Object} user - Usuario autenticado
 * @returns {Promise} Response con lista de servicios
 */
export const getServiciosSpread = async (user) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/generales/servicios-spread`;
    
    const response = await axios.get(endpoint, config);
    
    return {
      success: true,
      data: response.data.data || [],
      total: response.data.total || 0,
      message: response.data.message || 'Servicios Spread obtenidos exitosamente'
    };
  } catch (error) {
    console.error('Error al obtener servicios spread:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener servicios spread',
      data: [],
      total: 0
    };
  }
};

/**
 * Obtener clientes
 * @param {Object} user - Usuario autenticado
 * @returns {Promise} Response con lista de clientes
 */
export const getClientes = async (user) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/generales/clientes`;
    
    const response = await axios.get(endpoint, config);
    
    return {
      success: true,
      data: response.data.data || [],
      total: response.data.total || 0,
      message: response.data.message || 'Clientes obtenidos exitosamente'
    };
  } catch (error) {
    console.error('Error al obtener clientes:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener clientes',
      data: [],
      total: 0
    };
  }
};
